import Icon from "components/icon";
import { pushDrawer } from "~/composables/useDrawers";
import { AIConversation } from "../../components/conversation";
import {
  showFeatureBase,
} from "@/integrations/featurebase/utils";
import { ChatButton } from "../../components/chat-button";
import WithBubbletip from "components/with-bubbletip";
import { sendFeaturebaseFeedback } from "@/integrations/featurebase/utils";
import { pushDisclaimerModal } from "../disclaimer";
import { useCurrentUser } from "@/modules/user/hooks/useCurrentUser";
import { lerp } from "math";
import { useResponsive } from "~/composables/useResponsive";
//import { AIConversation } from '../../components/conversation'

const BetaTooltip = defineComponent(() => {
  return () => {
    return (
      <div
        class="self-stretch justify-center max-w-[400px] select-none pointer-events-all"
        style={{ pointerEvents: "all" }}
      >
        <div class="text-gray-900 text-xs font-bold font-['Inter']">
          Beta Feature
        </div>
        <span class="text-gray-500 text-xs font-normal font-['Inter']">
          This AI Agent is currently in beta and under active development.
          Features may change, and you might experience occasional issues or
          limitations.
          <br />
        </span>
        <span class="text-gray-500 text-xs font-medium font-['Inter']">
          <br />
        </span>
        <div class="text-gray-900 text-xs font-semibold font-['Inter']">
          Help us improve!
        </div>
        <span class="text-gray-500 text-xs font-normal font-['Inter']">
          If you encounter any problems or have suggestions for improvements,
          please send us your feedback as it helps us make Findex AI better for
          everyone.
        </span>
        <div
          onClick={() => {
            sendFeaturebaseFeedback();
          }}
          class="text-primary-500 text-xs font-bold font-['Inter'] underline cursor-pointer"
        >
          Send Feedback
        </div>
      </div>
    );
  };
});

export const pushAIConversationModal = async () => {
  const { user } = useCurrentUser();

  if (!user.value.agreedAIUsageDate) {
    const accepted = await pushDisclaimerModal();
    if (!accepted) return;
  }

  const responsive = useResponsive();

  pushDrawer({
    key: "ai-conversation-drawer",
    topBar: () => {
      return (
        <div class="h-full grid items-center">
          <div class="w-48 inline-flex justify-start items-center gap-2">
            {/*<div class="w-6 h-6 px-[3px] py-[5px] bg-primary-100 rounded-xs inline-flex flex-col justify-center items-center gap-2 overflow-hidden">
              <Icon
                size="1.6rem"
                src={async () => import("assets/img/svg/icons/frame.svg?raw")}
              />
            </div>*/}
            <div class="flex justify-start items-center">
              <div class="justify-start text-gray-900 text-sm font-semibold font-['Inter'] leading-tight">
                Midas AI
              </div>
            </div>
            <WithBubbletip
              tooltip={{
                variant: "white",
                placement: "bottom",
                hoverable: true,
                wrapText: true,
                body: () => <BetaTooltip />,
              }}
            >
              <div class="px-2 py-0.5 border border-gray-300 rounded-sm flex justify-center items-center">
                <div class="text-gray-500 text-[10px] font-medium font-['Inter'] leading-none tracking-wide uppercase">
                  Beta
                </div>
              </div>
            </WithBubbletip>
          </div>
        </div>
      );
    },
    topBarActions: (props) => {
      const handleMaximize = () => {
        props.hook.toggleExpanded();
      };
      const handleChangeDirection = () => {
        props.hook.toggleDirection();
      };
      const flipRotation = computed(() =>
        lerp(0, 180, 1.0 - (0.5 + 0.5 * props.hook.direction.value)),
      );
      return (
        <div class="inline-flex items-center gap-2">
          {responsive.isPhone.value ? null : (
            <>
              <ChatButton variant="default" onClick={handleChangeDirection}>
                <Icon
                  stroke="currentColor"
                  size="0.625rem"
                  style={{
                    rotate: `${flipRotation.value}deg`,
                  }}
                  src={async () =>
                    import("assets/img/svg/icons/side-flip.svg?raw")
                  }
                />
              </ChatButton>
              <ChatButton
                variant={computed(() =>
                  props.hook.expanded.value ? "primary" : "default",
                )}
                onClick={handleMaximize}
              >
                <Icon
                  fill="currentColor"
                  size="0.625rem"
                  src={async () =>
                    import("assets/img/svg/icons/maximize.svg?raw")
                  }
                />
              </ChatButton>
            </>
          )}
        </div>
      );
    },
    body: () => {
      return <AIConversation />;
    },
    onClose: () => {
      showFeatureBase();
    },
  });
};
